;(() => {
  const modal = document.querySelector('section#modal')
  const modalBackground = document.querySelector(
    'section#modal .modal-background'
  )
  const modalClose = document.querySelector('section#modal button.close')

  modalBackground.addEventListener('click', function () {
    closeModal()
  })

  modalClose.addEventListener('click', function () {
    closeModal()
  })

  function closeModal() {
    modal.classList.remove('active')
    document.querySelector('section#modal main.wrapper').innerHTML = ''
  }
})()
